import type React from 'react'

import css from './Divider.module.scss'

const Divider: React.FC = () => <div className={css.container} />

export default Divider
